/**
 * The `?verify=` values that open a step of `PhoneVerifyModal`. Anything else leaves the modal shut. Import-free,
 * so `phone-connect` and the WhatsApp sheet can name a step without importing the modal that renders it.
 */
export const VERIFY_PHONE = 'phone';
export const VERIFY_CODE = 'code';
/**
 * The number step, opened by the caller from the rail instead of by the assistant. Same step and same
 * flow — a separate value only because the two arrive with different wording: the assistant is already
 * mid-sentence about why it needs a number, where the rail has to make the case from nothing.
 */
export const VERIFY_CONNECT = 'connect';
/**
 * The number step and nothing before it. `phone` and `connect` open "Verify with WhatsApp" first while no phone is
 * on file; its "Enter my number instead" lands here, so the person is never sent back to the sheet they just left.
 */
export const VERIFY_NUMBER = 'number';
